import { url } from "@/utils/urls";

export const URLS = {
  auth: {
    authCallback: url("/auth-callback/"),
    login: url("/login/"),
  },
  account: {
    logout: url("/account/logout/"),
  },
  dashboard: {
    index: url("/"),
  },
  serviceManagement: {
    key: url("/service-management/"),
    circuits: {
      list: url(
        "/service-management/circuits/:action?/:id?/:childUrl?/:childAction?/:childId?/",
      ),
    },
    devicesAndContracts: {
      key: url("/service-management/devices-and-contracts/"),
      devices: {
        list: url(
          "/service-management/devices-and-contracts/devices/:action?/:id?/:childUrl?/:childAction?/:childId?/",
        ),
      },
      maintenanceContracts: {
        list: url(
          "/service-management/devices-and-contracts/maintenance-contracts/:action?/:id?/:childUrl?/:childAction?/:childId?/",
        ),
      },
    },
    locations: {
      list: url("/service-management/locations/:action?/:id?/"),
    },
    services: {
      list: url("/service-management/services/:action?/:id?/"),
    },
    mobileVoice: {
      key: url("/service-management/mobile-voice/"),
      simCards: {
        list: url("/service-management/mobile-voice/sim-cards/:action?/:id?/"),
        detail: url("/service-management/mobile-voice/sim-cards/:id?/"),
        update: url("/service-management/mobile-voice/sim-cards/update/:id?/"),
      },
    },
    mobile: {
      key: url("/service-management/mobile/"),
      cellularSIMCards: {
        list: url(
          "/service-management/mobile/cellular-sim-cards/:action?/:id?/",
        ),
      },
      cellularSIMCardChangeLogs: {
        list: url("/service-management/mobile/cellular-sim-card-change-logs/"),
      },
    },
    netsgMobile: {
      key: url("/service-management/netsg-mobile/"),
      services: {
        list: url("/service-management/netsg-mobile/services/:action?/:id?/"),
      },
      pools: {
        list: url("/service-management/netsg-mobile/pools/:action?/:id?/"),
      },
      simCards: {
        // Legacy route — the SIM cards screen was folded into the services
        // screen; kept only so old bookmarks redirect there.
        list: url("/service-management/netsg-mobile/sim-cards/:action?/:id?/"),
      },
    },
    managedServices: {
      list: url("/service-management/managed-services/:action?/:id?/"),
    },
  },
  orderManagement: {
    key: url("/order-management/"),
    orders: {
      list: url(
        "/order-management/orders/:action?/:id?/:childUrl?/:childAction?/:childId?/",
      ),
    },
    workflows: {
      index: url("/order-management/workflows/"),
    },
  },
  clientManagement: {
    key: url("/client-management/"),
    companies: {
      list: url(
        "/client-management/companies/:action?/:id?/:childUrl?/:childAction?/:childId?/",
      ),
    },
    contacts: {
      list: url("/client-management/contacts/:action?/:id?/"),
      update: url("/client-management/contacts/update/:id?/"),
    },
  },
  changeManagement: {
    key: url("/change-management/"),
    calendar: url("/change-management/calendar/"),
    changes: {
      list: url("/change-management/changes/:action?/:id?/"),
    },
    requests: {
      preview: url("/change-management/preview-request/:id/"),
      list: url("/change-management/requests/:action?/:id?/"),
    },
  },
  voiceBilling: {
    key: url("/voice-billing/"),
    SIPTrunks: {
      list: url("/voice-billing/sip-trunks/:action?/:id?/"),
    },
    phoneNumberRanges: {
      list: url("/voice-billing/phone-number-ranges/:action?/:id?/"),
    },
    answerPoints: {
      list: url("/voice-billing/answer-points/:action?/:id?/"),
    },
  },
  reports: {
    key: url("/reports/"),
    invoices: url("/reports/invoices/"),
    circuitsStartDateDelta: url("/reports/circuits-start-date-delta/"),
    ordersPDDStatus: url("/reports/orders-pdd-status/"),
    deviceFirmware: url("/reports/device-firmware/"),
    devicesPerManagedService: url("/reports/devices-per-managed-service/"),
    siteDeploymentStatus: url("/reports/site-deployment-status/"),
  },
  admin: {
    key: url("/admin/"),
    userAndGroups: {
      key: url("/admin/user-and-groups/"),
      users: {
        list: url("/admin/user-and-groups/users/:action?/:id?/"),
      },
      userGroups: {
        list: url("/admin/user-and-groups/user-groups/:action?/:id?/"),
      },
      permissions: {
        list: url("/admin/user-and-groups/permissions/:action?/:id?/"),
      },
      permissionsSets: {
        list: url("/admin/user-and-groups/permissions-sets/:action?/:id?/"),
      },
    },
    circuitsAndDevices: {
      key: url("/admin/circuit-and-devices/"),
      circuitTypes: {
        list: url("/admin/circuit-and-devices/circuit-types/:action?/:id?/"),
      },
      deviceManufacturers: {
        list: url(
          "/admin/circuit-and-devices/device-manufacturers/:action?/:id?/",
        ),
      },
      deviceTags: {
        list: url("/admin/circuit-and-devices/device-tags/:action?/:id?/"),
      },
      interfaceConfigurations: {
        list: url(
          "/admin/circuit-and-devices/interface-configurations/:action?/:id?/",
        ),
      },
      bandwidths: {
        list: url("/admin/circuit-and-devices/bandwidths/:action?/:id?/"),
      },
      interfaceTypes: {
        list: url("/admin/circuit-and-devices/interface_types/:action?/:id?/"),
      },
      deviceCategories: {
        list: url(
          "/admin/circuit-and-devices/device-categories/:action?/:id?/",
        ),
      },
    },
    vendorManagement: {
      key: url("/admin/vendor-management/"),
      carriers: {
        list: url("/admin/vendor-management/carriers/:action?/:id?/"),
      },
      maintenanceOrganizations: {
        list: url(
          "/admin/vendor-management/maintenance-organizations/:action?/:id?/",
        ),
      },
    },
    provisioning: {
      key: url("/admin/provisioning/"),
      customerStatuses: {
        list: url("/admin/provisioning/customer-statuses/:action?/:id?/"),
      },
    },
    serviceMessages: {
      key: url("/admin/service-messages/"),
      list: url("/admin/service-messages/:action?/:id?/"),
    },
    emailSettings: {
      key: url("/admin/email-settings/"),
      emailSettings: {
        list: url("/admin/email-settings/email-settings/:action?/:id?/"),
      },
      emails: {
        list: url("/admin/email-settings/emails/:action?/:id?/"),
      },
    },
    productManagement: {
      key: url("/admin/product-management/"),
      handoverDocumentTemplates: {
        list: url(
          "/admin/product-management/handover-document-templates/:action?/:id?/",
        ),
      },
      serviceCategories: {
        list: url(
          "/admin/product-management/service-categories/:action?/:id?/",
        ),
      },
      serviceTypes: {
        list: url("/admin/product-management/service-types/:action?/:id?/"),
      },
      mobilePlans: {
        list: url("/admin/product-management/mobile-plans/:action?/:id?/"),
      },
      mobileAddons: {
        list: url("/admin/product-management/mobile-bolt-ons/:action?/:id?/"),
      },
      workPlanTemplates: {
        list: url(
          "/admin/product-management/work-plan-templates/:action?/:id?/",
        ),
      },
    },
    connectwise: {
      key: url("/admin/connectwise/"),
      syncEvents: {
        list: url("/admin/connectwise/sync-events/:action?/:id?/"),
      },
    },
    netbrm: {
      key: url("/admin/netbrm/"),
      overview: {
        index: url("/admin/netbrm/overview/"),
      },
      mappings: {
        list: url("/admin/netbrm/catalog-mappings/:action?/:id?/"),
      },
      commands: {
        list: url("/admin/netbrm/sync-queue/:action?/:id?/"),
      },
      links: {
        list: url("/admin/netbrm/links/:action?/:id?/"),
      },
      accountLinks: {
        list: url("/admin/netbrm/account-overrides/:action?/:id?/"),
      },
      restrictionDecisions: {
        list: url("/admin/netbrm/restriction-decisions/:action?/:id?/"),
      },
      events: {
        list: url("/admin/netbrm/webhook-events/:action?/:id?/"),
      },
      inboundOrders: {
        list: url("/admin/netbrm/inbound-orders/:action?/:id?/"),
      },
      companyBilling: {
        list: url("/admin/netbrm/company-billing/:action?/:id?/"),
      },
    },
    voiceBilling: {
      key: url("/admin/voice-billing/"),
      voiceCodecs: {
        list: url("/admin/voice-billing/voice-codecs/:action?/:id?/"),
      },
    },
    formBuilder: {
      key: url("/admin/form-builder/"),
      forms: {
        list: url("/admin/form-builder/forms/:action?/:id?/"),
      },
      templates: {
        list: url("/admin/form-builder/templates/:action?/:id?/"),
      },
    },
    operations: {
      key: url("/admin/operations/"),
      circuitRelocation: {
        index: url("/admin/operations/circuit-relocation/"),
      },
      tagManagement: {
        index: url("/admin/operations/tag-management/"),
      },
    },
  },
  userInvitations: {
    acceptInvitation: url("/i/:invitationKey/"),
  },
  customerUI: {
    dashboard: {
      index: url("/"),
    },
    companyProfile: {
      index: url("/company-profile/"),
    },
    serviceDelivery: {
      index: url("/service-delivery/"),
      detail: url("/service-delivery/:id/"),
    },
    services: {
      index: url("/services/"),
      detail: url("/services/:id/"),
    },
    mobileVoice: {
      index: url("/mobile-voice/"),
      detail: url("/mobile-voice/:id/"),
    },
    netsgMobile: {
      key: url("/netsg-mobile/"),
      services: {
        index: url("/netsg-mobile/services/"),
        detail: url("/netsg-mobile/services/:id/"),
      },
      pools: {
        index: url("/netsg-mobile/pools/"),
        detail: url("/netsg-mobile/pools/:id/"),
      },
    },
    managedServices: {
      index: url("/managed-services/"),
      detail: url("/managed-services/:id/"),
      devices: {
        detail: url("/managed-services/:id/devices/:deviceId/"),
      },
    },
    changeManagement: {
      key: url("/change-management/"),
      changes: {
        index: url("/change-management/changes/"),
        detail: url("/change-management/changes/:id/"),
      },
      requests: {
        index: url("/change-management/requests/"),
        detail: url("/change-management/requests/:id/"),
      },
    },
    support: {
      index: url("/support/"),
      openTicket: url("/support/tickets/open/"),
      detail: url("/support/tickets/:id/"),
    },
    reports: {
      index: url("/reports/"),
      services: url("/reports/data-and-voice-services/"),
      supportTickets: url("/reports/support-requests/"),
      changeManagement: url("/reports/change-management/"),
      managedDevices: url("/reports/managed-devices/"),
      managedServicesDeviceAvailability: url(
        "/reports/managed-device-availability/",
      ),
      serviceAvailability: url("/reports/data-services-availability/"),
      alertHistory: url("/reports/alert-history/"),
      circuitUtilizationByLocation: url(
        "/reports/circuit-utilization-by-location/",
      ),
      siteDeploymentStatus: url("/reports/site-deployment-status/"),
    },
    forms: {
      detail: url("/forms/:id/"),
    },
    monitoring: {
      key: url("/monitoring/"),
      ddos: {
        index: url("/monitoring/ddos-protect/"),
        monitoring: {
          index: url("/monitoring/ddos-protect/monitoring/"),
        },
        protectedObjects: {
          index: url("/monitoring/ddos-protect/protected-objects/"),
        },
        mitigations: {
          index: url("/monitoring/ddos-protect/mitigations/"),
        },
      },
      myNetwork: {
        index: url("/monitoring/my-network/"),
      },
    },
    userInvitations: {
      acceptInvitation: url("/i/:invitationKey/"),
    },
  },
  publicUI: {
    forms: {
      detail: url("/forms/:id/"),
    },
    changeManagement: {
      requests: {
        detail: url("/change-requests/:id/"),
      },
    },
    userInvitations: {
      acceptInvitation: url("/i/:invitationKey/"),
    },
  },
};

export const DATA_URLS = {
  generic: {
    ws: {
      version: url("/ws/generic/version/"),
    },
  },
  internal: {
    auth: {
      validateADToken: url("/auth/validate_ad_token/"),
      loginAs: url("/auth/login_as/"),
      reLoginAsSelf: url("/auth/relogin_as_self/"),
      userInfo: url("/auth/user_info/"),
      changePassword: url("/auth/change_password/"),
      logActivity: url("/auth/log_activity/"),
      accessNotification: url("/auth/access_notification/"),
      switchCompany: url("/auth/switch_company/"),
    },
    bandwidths: {
      list: url("/bandwidths/"),
      details: url("/bandwidths/:pk/"),
      ws: {
        list: url("/ws/bandwidths/listen/"),
        details: url("/ws/bandwidths/:pk/listen/"),
      },
    },
    carriers: {
      list: url("/carriers/"),
      ws: {
        list: url("/ws/carriers/listen/"),
        details: url("/ws/carriers/:pk/listen/"),
      },
    },
    changeManagement: {
      calendar: url("/change_management/calendar/"),
      calendarLeave: url("/change_management/calendar/leave/"),
      changes: {
        list: url("/change_management/changes/"),
        ws: {
          list: url("/ws/change_management/changes/listen/"),
          details: url("/ws/change_management/changes/:pk/listen/"),
        },
        affectedClientCompanies: url(
          "/change_management/changes/:pk/affected_client_companies/",
        ),
        affectedPartnerCompanies: url(
          "/change_management/changes/:pk/affected_partner_companies/",
        ),
        sendChangeNotificationsToClients: url(
          "/change_management/changes/:pk/send_change_notifications_to_clients/",
        ),
        sendChangeNotificationsToPartners: url(
          "/change_management/changes/:pk/send_change_notifications_to_partners/",
        ),
        sendTestEmail: url("/change_management/changes/:pk/send_test_email/"),
      },
      requests: {
        list: url("/change_management/change_requests/"),
        details: url("/change_management/change_requests/:pk/"),
        internalPreview: url(
          "/change_management/change_requests/:pk/internal_preview/",
        ),
        sendApprovalEmails: url(
          "/change_management/change_requests/:pk/send_approval_emails/",
        ),
        resendApprovalEmails: url(
          "/change_management/change_requests/:pk/resend_approval_emails/",
        ),
        markAsCompleted: url(
          "/change_management/change_requests/:pk/mark_as_completed/",
        ),
        duplicate: url("/change_management/change_requests/:pk/duplicate/"),
        history: url("/change_management/change_requests/:pk/history/"),
      },
      requestApprovals: {
        list: url("/change_management/change_request_approvals/"),
        getByUniqueId: url(
          "/change_management/change_request_approvals/:unique_id/get_by_unique_id/",
        ),
        approve: url(
          "/change_management/change_request_approvals/:pk/approve/",
        ),
        reject: url("/change_management/change_request_approvals/:pk/reject/"),
      },
      changeRequestManualApprovals: {
        list: url("/change_management/change_request_manual_approvals/"),
        details: url("/change_management/change_request_manual_approvals/:pk/"),
      },
      requestEvents: {
        list: url("/change_management/change_request_events/"),
      },
      changeEvents: {
        list: url("/change_management/change_events/"),
        notificationsPreview: url(
          "/change_management/change_events/:pk/notifications_preview/",
        ),
        sendNotifications: url(
          "/change_management/change_events/:pk/send_notifications/",
        ),
        sendTestEmail: url(
          "/change_management/change_events/:pk/send_test_email/",
        ),
      },
      changeTypes: {
        list: url("/change_management/change_types/"),
      },
      changeStatuses: {
        list: url("/change_management/change_statuses/"),
      },
      changeRiskTypes: {
        list: url("/change_management/change_risk_types/"),
      },
      changeUrgencyTypes: {
        list: url("/change_management/change_urgency_types/"),
      },
      changeImpactTypes: {
        list: url("/change_management/change_impact_types/"),
      },
      changeCategoryTypes: {
        list: url("/change_management/change_category_types/"),
      },
      companyCases: {
        list: url("/change_management/cases/"),
      },
    },
    circuits: {
      list: url("/circuits/"),
      short: url("/circuits/short/"),
      expiring: url("/circuits/expiring/"),
      attached: url("/circuits/attached/"),
      unattached: url("/circuits/unattached/"),
      summary: url("/circuits/summary/"),
      relocate: url("/circuits/relocate/"),
      details: url("/circuits/:pk/"),
      monitoring: url("/circuits/monitoring/"),
      replicateInNetbox: url("/circuits/:pk/replicate_in_netbox/"),
      ws: {
        list: url("/ws/circuits/listen/"),
        details: url("/ws/circuits/:pk/listen/"),
      },
      types: {
        list: url("/circuits/types/"),
        ws: {
          list: url("/ws/circuits/types/listen/"),
          details: url("/ws/circuits/types/:pk/listen/"),
        },
      },
      subtypes: {
        list: url("/circuits/subtypes/"),
        ws: {
          list: url("/ws/circuits/subtypes/listen/"),
          details: url("/ws/circuits/subtypes/:pk/listen/"),
        },
      },
      attachments: {
        list: url("/circuits/attachments/"),
        details: url("/circuits/attachments/:pk/"),
      },
    },
    companies: {
      list: url("/companies/"),
      ws: {
        list: url("/ws/companies/listen/"),
        details: url("/ws/companies/:pk/listen/"),
      },
      externalCompanies: url("/companies/get_external_companies/"),
      details: url("/companies/:pk/"),
      companyContacts: {
        list: url("/companies/contacts/"),
        details: url("/companies/contacts/:pk/"),
        ws: {
          list: url("/ws/companies/contacts/listen/"),
          details: url("/ws/companies/contacts/:pk/listen/"),
        },
      },
      companyProfile: {
        details: url("/companies/profile/"),
        companyContacts: {
          list: url("/companies/profile/contacts/"),
          details: url("/companies/profile/contacts/:pk/"),
          sendWhatsAppVerification: url(
            "/companies/profile/contacts/:pk/send-whatsapp-verification/",
          ),
          verifyWhatsAppNumber: url(
            "/companies/profile/contacts/:pk/verify-whatsapp-number/",
          ),
        },
        companyCustomers: {
          list: url("/companies/profile/customers/"),
        },
      },
    },
    contacts: {
      list: url("/contacts/"),
      ws: {
        list: url("/ws/contacts/listen/"),
        details: url("/ws/contacts/:pk/listen/"),
      },
      details: url("/contacts/:pk/"),
      categoryTypes: {
        list: url("/contacts/category_types/"),
      },
    },
    customerHandover: {
      handoverDocumentTemplates: {
        list: url("/customer_handover/handover_document_templates/"),
        preview: url("/customer_handover/handover_document_templates/preview/"),
        ws: {
          list: url(
            "/ws/customer_handover/handover_document_templates/listen/",
          ),
          details: url(
            "/ws/customer_handover/handover_document_templates/:pk/listen/",
          ),
        },
      },
    },
    devices: {
      list: url("/devices/"),
      short: url("/devices/short/"),
      monitoring: url("/devices/monitoring/"),
      expiring: url("/devices/expiring/"),
      nmsOsIssues: url("/devices/nms_os_issues/"),
      withMaintenanceContracts: url("/devices/with_maintenance_contracts/"),
      validForManagedServices: url("/devices/valid_for_managed_services/"),
      details: url("/devices/:pk/"),
      associatedServices: url("/devices/:pk/services/"),
      associatedCircuits: url("/devices/:pk/circuits/"),
      associatedManagedServices: url("/devices/:pk/managed_services/"),
      updateTags: url("/devices/update_tags/"),
      ws: {
        list: url("/ws/devices/listen/"),
        details: url("/ws/devices/:pk/listen/"),
        customerAlerts: url("/ws/devices/customer/alert_events/listen/"),
      },
      tags: {
        list: url("/devices/tags/"),
      },
      attachments: {
        list: url("/devices/attachments/"),
        ws: {
          list: url("/ws/devices/attachments/listen/"),
          details: url("/ws/devices/attachments/:pk/listen/"),
        },
      },
      manufacturers: {
        list: url("/devices/manufacturers/"),
        ws: {
          list: url("/ws/devices/manufacturers/listen/"),
          details: url("/ws/devices/manufacturers/:pk/listen/"),
        },
      },
      aggregationPorts: {
        list: url("/devices/aggregation_ports/"),
        ws: {
          list: url("/ws/devices/aggregation_ports/listen/"),
          details: url("/ws/devices/aggregation_ports/:pk/listen/"),
        },
      },
      models: {
        list: url("/devices/models/"),
        ws: {
          list: url("/ws/devices/models/listen/"),
          details: url("/ws/devices/models/:pk/listen/"),
        },
      },
      interfaceConfigurations: {
        list: url("/devices/interface_configurations/"),
        ws: {
          list: url("/ws/devices/interface_configurations/listen/"),
          details: url("/ws/devices/interface_configurations/:pk/listen/"),
        },
      },
      categories: {
        list: url("/devices/categories/"),
        ws: {
          list: url("/ws/devices/categories/listen/"),
          details: url("/ws/devices/categories/:pk/listen/"),
        },
      },
      configAbbreviations: {
        list: url("/devices/config_abbreviations/"),
      },
    },
    interfaceTypes: {
      list: url("/interface_types/"),
      ws: {
        list: url("/ws/interface_types/listen/"),
        details: url("/ws/interface_types/:pk/listen/"),
      },
    },
    locations: {
      list: url("/locations/"),
      details: url("/locations/:pk/"),
      associatedServices: url("/locations/:pk/services/"),
      associatedCircuits: url("/locations/:pk/circuits/"),
      associatedDevices: url("/locations/:pk/devices/"),
      associatedManagedServices: url("/locations/:pk/managed_services/"),
      ws: {
        list: url("/ws/locations/listen/"),
        details: url("/ws/locations/:pk/listen/"),
      },
      addressFinder: {
        addressAutocomplete: url(
          "/locations/addressfinder/address_autocomplete/",
        ),
        addressMetadata: url(
          "/locations/addressfinder/address_metadata/:af_address_id/",
        ),
      },
    },
    managedServices: {
      list: url("/managed_services/"),
      details: url("/managed_services/:pk/"),
      ws: {
        list: url("/ws/managed_services/listen/"),
        details: url("/ws/managed_services/:pk/listen/"),
      },
    },
    maintenance: {
      organizations: {
        list: url("/maintenance/organizations/"),
        ws: {
          list: url("/ws/maintenance/organizations/listen/"),
          details: url("/ws/maintenance/organizations/:pk/listen/"),
        },
      },
      contracts: {
        list: url("/maintenance/contracts/"),
        addDevices: url("/maintenance/contracts/:pk/add_devices/"),
        removeDeviceFromContract: url(
          "/maintenance/contracts/remove_maintained_device_from_contract/:pk/",
        ),
        ws: {
          list: url("/ws/maintenance/contracts/listen/"),
          details: url("/ws/maintenance/contracts/:pk/listen/"),
        },
      },
    },
    mentions: {
      unread: url("/mentions/unread/"),
      history: url("/mentions/history/"),
      markAllAsRead: url("/mentions/mark_all_as_read/"),
      markAsRead: url("/mentions/:pk/mark_as_read/"),
      ws: {
        unread: url("/ws/mentions/unread/listen/"),
      },
    },
    notifications: {
      types: {
        list: url("/notifications/notification_types/"),
        details: url("/ws/notifications/notification_types/:pk/listen/"),
      },
      emails: {
        list: url("/notifications/emails/"),
        ws: {
          list: url("/ws/notifications/emails/listen/"),
          details: url("/ws/notifications/emails/:pk/listen/"),
        },
      },
      emailEvents: {
        list: url("/notifications/email_events/"),
      },
      emailSettings: {
        list: url("/notifications/email_settings/"),
        ws: {
          list: url("/ws/notifications/email_settings/listen/"),
          details: url("/ws/notifications/email_settings/:pk/listen/"),
        },
      },
      events: {
        types: {
          list: url("/notifications/event_types/"),
        },
      },
    },
    orders: {
      list: url("/orders/"),
      mobile: {
        list: url("/orders/mobile"),
        details: url("/orders/mobile/:pk/"),
        update: url("/orders/mobile/:pk/"),
      },
      grouped: url("/orders/grouped/"),
      ws: {
        list: url("/ws/internal/orders/listen/"),
        details: url("/ws/internal/orders/:pk/listen/"),
      },
      summary: {
        list: url("/orders/summary/"),
        details: url("/orders/summary/:pk/"),
        submitEnquiryRequest: url(
          "/orders/summary/:pk/submit_enquiry_request/",
        ),
        ws: {
          details: url("/ws/orders/summary/:pk/listen/"),
        },
      },
      provisioningStatistic: url("/orders/provisioning_statistic/"),

      cancel: url("/orders/:pk/cancel/"),
      updateAffectedDevices: url("/orders/:pk/update_affected_devices/"),
      generateHandoverPackDocument: url(
        "/orders/:pk/generate_handover_pack_document/",
      ),
      sendProvisioningUpdate: url("/orders/:pk/send_provisioning_update/"),
      bulk: {
        sendProvisioningUpdate: url("/orders/bulk_send_provisioning_update/"),
        updateProvisioningStatus: url(
          "/orders/bulk_update_provisioning_status/",
        ),
        addComment: url("/orders/bulk_add_comment/"),
        updateDates: url("/orders/bulk_update_dates/"),
      },
      syncWithConnectWise: url("/orders/:pk/sync_with_connectwise/"),
      createWorkPlan: url("/orders/:pk/create_work_plan/"),
      detachFromConnectWise: url("/orders/:pk/detach_from_connectwise/"),
      generateQuestionnaireForm: url(
        "/orders/:pk/generate_questionnaire_form/",
      ),
      details: url("/orders/:pk/"),
      update: url("/orders/:pk/:action/"),
      progress: url("/orders/:pk/progress/"),
      workPlan: url("/orders/:pk/work_plan/"),
      workPlanTask: url("/orders/:pk/work_plan/tasks/:task_id/"),
      follow: url("/orders/:pk/follow/"),
      unfollow: url("/orders/:pk/unfollow/"),
      pinComment: url("/orders/:pk/pin_comment/"),
      conversation: url("/orders/:pk/conversation/"),
      conversationAttachment: url(
        "/orders/:pk/conversation/attachments/:attachment_id/",
      ),
      retryNetcrmCase: url("/orders/:pk/retry_netcrm_case/"),

      workPlans: {
        phases: {
          update: url("/orders/work_plan/:work_plan_id/phases/:phase_id/"),
        },
        tickets: {
          update: url(
            "/orders/work_plan/:work_plan_id/tickets/update/:ticket_id/",
          ),
          details: url("/orders/work_plan/:work_plan_id/tickets/:ticket_id/"),
          timeEntries: {
            list: url(
              "/orders/work_plan/:work_plan_id/tickets/:ticket_id/time_entries/",
            ),
          },
        },
        grouped: {
          list: url("/orders/work_plan/grouped/"),
        },
        phaseStatuses: {
          list: url("/orders/work_plan/phase_statuses/"),
        },
        taskStatuses: {
          list: url("/orders/work_plan/task_statuses/"),
        },
        taskPriorities: {
          list: url("/orders/work_plan/task_priorities/"),
        },
      },
      workOrders: {
        list: url("/orders/work_orders/"),
      },
      attachments: {
        list: url("/orders/attachments/"),
      },
      attachmentTypes: {
        list: url("/orders/attachment_types/"),
      },
      changeTypes: {
        list: url("/orders/change_types/"),
      },
      types: {
        list: url("/orders/types/"),
      },
      comments: {
        list: url("/orders/comments/"),
        createAcknowledgements: url(
          "/orders/comments/create_acknowledgements/",
        ),
      },
    },
    permissions: {
      list: url("/permissions/"),
      groups: {
        list: url("/permissions/groups/"),
        ws: {
          list: url("/ws/permissions/groups/listen/"),
          details: url("/ws/permissions/groups/:pk/listen/"),
        },
      },
      sets: {
        list: url("/permissions/sets/"),
        ws: {
          list: url("/ws/permissions/permission_sets/listen/"),
          details: url("/ws/permissions/permission_sets/:pk/listen/"),
        },
      },
      userGroupRelationships: {
        list: url("/permissions/user_group_relationships/"),
      },
    },
    plugins: {
      connectWise: {
        syncEvents: {
          list: url("/plugins/connectwise/sync_events/"),
          ws: {
            list: url("/ws/plugins/connectwise/sync_events/listen/"),
            details: url("/ws/plugins/connectwise/sync_events/:pk/listen/"),
          },
        },
        events: {
          types: {
            list: url("/plugins/connectwise/event_types/"),
          },
        },
      },
      telcoinabox: {
        address: {
          validate: url("/plugins/telcoinabox/address/validate/"),
        },
        simCards: {
          checkAvailability: url(
            "/plugins/telcoinabox/sim-cards/check-availability/",
          ),
          otp: {
            send: url("/plugins/telcoinabox/sim-cards/otp/send/"),
            verify: url("/plugins/telcoinabox/sim-cards/otp/verify/"),
          },
          plans: url("/plugins/telcoinabox/sim-cards/plans/"),
        },
        customers: {
          list: url("/plugins/telcoinabox/customers/"),
        },
        offers: {
          list: url("/plugins/telcoinabox/offers/"),
        },
      },
      netbox: {
        sites: {
          list: url("/plugins/netbox/sites/"),
        },
      },
    },
    serviceMessages: {
      messages: {
        list: url("/service-messages/messages/"),
        ws: {
          list: url("/ws/service-messages/messages/listen/"),
          details: url("/ws/service-messages/messages/:pk/listen/"),
        },
        details: url("/service-messages/messages/:pk/"),
      },
      levels: {
        list: url("/service-messages/levels/"),
      },
      categories: {
        list: url("/service-messages/categories/"),
      },
    },
    provisioning: {
      customerStatuses: {
        list: url("/provisioning/customer_statuses/"),
        ws: {
          list: url("/ws/provisioning/customer_statuses/listen/"),
          details: url("/ws/provisioning/customer_statuses/:pk/listen/"),
        },
      },
      statusTypes: {
        list: url("/provisioning/status_types/"),
      },
      codenameTypes: {
        list: url("/provisioning/codename_types/"),
      },
      workPlanTemplates: {
        list: url("/provisioning/work_plan_templates/"),
        details: url("/provisioning/work_plan_templates/:pk/"),
        ws: {
          list: url("/ws/provisioning/work_plan_templates/listen/"),
          details: url("/ws/provisioning/work_plan_templates/:pk/listen/"),
        },
      },
    },
    services: {
      list: url("/services/"),
      short: url("/services/short/"),
      details: url("/services/:pk/"),
      topology: url("/services/:pk/topology/"),
      attachCellularSIMCard: url("/services/:pk/attach_cellular_sim_card/"),
      detachCellularSIMCard: url("/services/:pk/detach_cellular_sim_card/"),
      attachSIPTrunk: url("/services/:pk/attach_sip_trunk/"),
      detachSIPTrunk: url("/services/:pk/detach_sip_trunk/"),
      attachPhoneNumberRange: url("/services/:pk/attach_phone_number_range/"),
      detachPhoneNumberRange: url("/services/:pk/detach_phone_number_range/"),
      attachAnswerPoint: url("/services/:pk/attach_answer_point/"),
      detachAnswerPoint: url("/services/:pk/detach_answer_point/"),
      attachCircuit: url("/services/:pk/attach_circuit/"),
      detachCircuit: url("/services/:pk/detach_circuit/"),
      diversityAlerts: url("/services/diversity_alerts/"),
      acknowledgeDiversityAlert: url(
        "/services/:pk/acknowledge_diversity_alert/",
      ),
      diversityStatus: url("/services/:pk/diversity_status/"),
      ws: {
        list: url("/ws/services/listen/"),
        details: url("/ws/services/:pk/listen/"),
      },
      categories: {
        list: url("/services/categories/"),
        ws: {
          list: url("/ws/services/categories/listen/"),
          details: url("/ws/services/categories/:pk/listen/"),
        },
      },
      types: {
        list: url("/services/types/"),
        details: url("/services/types/:pk/"),
        ws: {
          list: url("/ws/services/types/listen/"),
          details: url("/ws/services/types/:pk/listen/"),
        },
      },
    },
    SIMCards: {
      list: url("/sim_cards/"),
      attached: url("/sim_carts/attached/"),
      unattached: url("/sim_cards/unattached/"),
      setTag: url("/sim_cards/:pk/set_tag/"),
      setStatus: url("/sim_cards/:pk/set_status/"),
      connectionHistory: url("/sim_cards/:pk/connection_history/"),
      ws: {
        list: url("/ws/sim_cards/listen/"),
        details: url("/ws/sim_cards/:pk/listen/"),
      },
      changeLogs: {
        list: url("/sim_cards/change_logs/"),
      },
    },
    telcoInabox: {
      list: url("/sim_cards/telcoinabox/sim_cards/"),
      mini: url("/sim_cards/telcoinabox/sim_cards/mini/"),
      fleets: url("/sim_cards/telcoinabox/fleets/"),
      attached: url("/sim_cards/telcoinabox/sim_cards/attached/"),
      setTag: url("/sim_cards/telcoinabox/sim_cards/:pk/set_tag/"),
      setContact: url("/sim_cards/telcoinabox/sim_cards/:pk/set_contact/"),
    },
    support: {
      issueTypes: {
        list: url("/support/issue_types/"),
      },
      incidentCategories: {
        list: url("/support/incident_categories/"),
      },
      incidentAffects: {
        list: url("/support/incident_affects/"),
      },
      incidentSeverity: {
        list: url("/support/incident_severity/"),
      },
      statuses: {
        list: url("/support/statuses/"),
      },
      ticketAttachments: {
        list: url("/support/ticket_attachments/"),
      },
    },
    users: {
      list: url("/users/"),
      manage: url("/users/manage/"),
      info: url("/users/info/:username/"),
      detail: url("/users/manage/:pk/"),
      loginHistory: url("/users/manage/:pk/login_history/"),
      externalMembers: url("/users/manage/external_members/"),
      ws: {
        list: url("/ws/users/listen/"),
        details: url("/ws/users/:pk/listen/"),
      },
    },
    voiceBilling: {
      phoneNumberRanges: {
        list: url("/voice_billing/phone_number_ranges/"),
        unattached: url("/voice_billing/phone_number_ranges/unattached/"),
        ws: {
          list: url("/ws/voice_billing/phone_number_ranges/listen/"),
          details: url("/ws/voice_billing/phone_number_ranges/:pk/listen/"),
        },
      },
      SIPTrunks: {
        list: url("/voice_billing/sip_trunks/"),
        unattached: url("/voice_billing/sip_trunks/unattached/"),
        ws: {
          list: url("/ws/voice_billing/sip_trunks/listen/"),
          details: url("/ws/voice_billing/sip_trunks/:pk/listen/"),
        },
      },
      voiceCodecs: {
        list: url("/voice_billing/voice_codecs/"),
        ws: {
          list: url("/ws/voice_billing/voice_codecs/listen/"),
          details: url("/ws/voice_billing/voice_codecs/:pk/listen/"),
        },
      },
      answerPoints: {
        list: url("/voice_billing/answer_points/"),
        unattached: url("/voice_billing/answer_points/unattached/"),
      },
    },
    releaseNotes: url("/release_notes/"),
    constructedForms: {
      list: url("/constructed_forms/forms/"),
      populateLinkedObjectData: url(
        "/constructed_forms/forms/:pk/populate_linked_object_data/",
      ),
      ws: {
        list: url("/ws/constructed_forms/forms/listen/"),
        details: url("/ws/constructed_forms/forms/:pk/listen/"),
      },
      templates: {
        list: url("/constructed_forms/templates/"),
        duplicate: url("/constructed_forms/templates/:pk/duplicate/"),
        ws: {
          list: url("/ws/constructed_forms/templates/listen/"),
          details: url("/ws/constructed_forms/templates/:pk/listen/"),
        },
        models: {
          list: url("/constructed_forms/templates/models/"),
        },
        modelFields: {
          list: url("/constructed_forms/templates/model_fields/"),
        },
      },
      templateFiles: {
        list: url("/constructed_forms/template_files/"),
      },
      templateTypes: {
        list: url("/constructed_forms/template_types/"),
      },
      public: {
        details: url("/constructed_forms/public/:pk/"),
        submit: url("/constructed_forms/public/:pk/submit/"),
      },
    },
    inbox: {
      inboundEmails: {
        list: url("/inbox/inbound_emails/"),
        details: url("/inbox/inbound_emails/:pk/"),
      },
    },
    reports: {
      SIMMasterPoolUsage: url("/reports/sim_master_pool_usage/"),
      invoices: url("/reports/invoices/"),
      ordersPDDStatus: url("/reports/orders_pdd_status/"),
      circuitsStartDateDelta: url("/reports/circuits_start_date_delta/"),
      deviceFirmware: url("/reports/device_firmware/"),
      devicesPerManagedService: url("/reports/devices_per_managed_service/"),
      siteDeploymentStatus: url("/reports/site_deployment_status/"),
    },
    netsgMobile: {
      services: {
        list: url("/netsg-mobile/services/"),
        details: url("/netsg-mobile/services/:pk/"),
        balance: url("/netsg-mobile/services/:pk/balance/"),
        setTag: url("/netsg-mobile/services/:pk/set-tag/"),
        setServiceContact: url(
          "/netsg-mobile/services/:pk/set-service-contact/",
        ),
        notificationSettings: url(
          "/netsg-mobile/services/:pk/notification-settings/",
        ),
      },
      pools: {
        list: url("/netsg-mobile/pools/"),
        details: url("/netsg-mobile/pools/:pk/"),
        usage: url("/netsg-mobile/pools/:pk/usage/"),
      },
      addons: {
        list: url("/netsg-mobile/addons/"),
        details: url("/netsg-mobile/addons/:pk/"),
      },
      plans: {
        list: url("/netsg-mobile/plans/"),
        details: url("/netsg-mobile/plans/:pk/"),
      },
      customers: {
        list: url("/netsg-mobile/customers/"),
        details: url("/netsg-mobile/customers/:pk/"),
      },
      catalogue: {
        plans: url("/netsg-mobile/catalogue/plans/"),
        addons: url("/netsg-mobile/catalogue/addons/"),
        features: url("/netsg-mobile/catalogue/features/"),
      },
      address: {
        validate: url("/netsg-mobile/address/validate/"),
      },
      numbers: {
        available: url("/netsg-mobile/numbers/available/"),
      },
      sims: {
        validate: url("/netsg-mobile/sims/validate/"),
      },
      octaneAccounts: {
        create: url("/netsg-mobile/octane-accounts/"),
      },
      otp: {
        send: url("/netsg-mobile/otp/send/"),
        verify: url("/netsg-mobile/otp/verify/"),
      },
      orders: {
        submit: url("/netsg-mobile/orders/"),
        refreshProvisioning: url(
          "/netsg-mobile/orders/:order_pk/provisioning/refresh/",
        ),
        backOut: url("/netsg-mobile/orders/:order_pk/back-out/"),
      },
    },
    netbrm: {
      status: url("/netbrm/status/"),
      sync: url("/netbrm/sync/"),
      mappingReport: url("/netbrm/mapping-report/"),
      catalogItems: url("/netbrm/catalog-items/"),
      mappings: {
        list: url("/netbrm/mappings/"),
        details: url("/netbrm/mappings/:pk/"),
      },
      accountLinks: {
        list: url("/netbrm/account-links/"),
        details: url("/netbrm/account-links/:pk/"),
      },
      links: {
        list: url("/netbrm/links/"),
        details: url("/netbrm/links/:pk/"),
      },
      commands: {
        list: url("/netbrm/commands/"),
        details: url("/netbrm/commands/:pk/"),
        retry: url("/netbrm/commands/:pk/retry/"),
      },
      events: {
        list: url("/netbrm/events/"),
        details: url("/netbrm/events/:pk/"),
      },
      restrictionDecisions: {
        list: url("/netbrm/restriction-decisions/"),
        details: url("/netbrm/restriction-decisions/:pk/"),
        acknowledge: url("/netbrm/restriction-decisions/:pk/acknowledge/"),
      },
      companyBilling: {
        list: url("/netbrm/company-billing/"),
        details: url("/netbrm/company-billing/:pk/"),
      },
      inboundOrders: {
        list: url("/netbrm/inbound-orders/"),
        details: url("/netbrm/inbound-orders/:pk/"),
        retry: url("/netbrm/inbound-orders/:pk/retry/"),
        ingest: url("/netbrm/inbound-orders/ingest/"),
      },
      inboundLines: {
        linkService: url("/netbrm/inbound-lines/:pk/link-service/"),
        unlinkService: url("/netbrm/inbound-lines/:pk/unlink-service/"),
      },
    },
  },
  external: {
    orders: {
      list: url("/orders/"),
      dashboard: url("/orders/dashboard/"),
      details: url("/orders/:pk/"),
      submitEnquiryRequest: url("/orders/:pk/submit_enquiry_request/"),
      conversation: url("/orders/:pk/conversation/"),
      conversationAttachment: url(
        "/orders/:pk/conversation/attachments/:attachment_id/",
      ),
      comments: {
        list: url("/orders/comments/"),
        createAcknowledgements: url(
          "/orders/comments/create_acknowledgements/",
        ),
      },
      ws: {
        details: url("/ws/external/orders/:pk/listen/"),
      },
    },
    devices: {
      list: url("/devices/"),
      monitoring: url("/devices/monitoring/"),
      openAlerts: url("/devices/alerts/"),
      config: url("/devices/:id/config/"),
      configContents: url("/devices/:id/config_contents/"),
      vulnerabilities: url("/devices/:id/vulnerabilities/"),
      vulnerabilitiesReport: url("/devices/:id/vulnerabilities/report/"),
    },
    managedServices: {
      list: url("/managed_services/"),
      details: url("/managed_services/:pk/"),
      hasManagedServices: url("/managed_services/has_managed_services/"),
    },
    services: {
      list: url("/services/"),
      network: {
        list: url("/services/network/"),
      },
      generateHandoverPackDocument: url(
        "/services/:pk/generate_handover_pack_document/",
      ),
      setTag: url("/services/:pk/set_tag/"),
    },
    reports: {
      serviceSnapshot: url("/reports/service_snapshot/"),
      services: url("/reports/services/"),
      supportTickets: url("/reports/support_tickets/"),
      changeManagement: url("/reports/change_management/"),
      managedDevices: url("/reports/managed_devices/"),
      managedServicesDeviceAvailability: url(
        "/reports/managed_services_device_availability/",
      ),
      serviceAvailability: url("/reports/service_availability/"),
      alertsHistory: url("/reports/alert_history/"),
      circuitUtilizationByLocation: url(
        "/reports/circuit_utilization_by_location/",
      ),
      siteDeploymentStatus: url("/reports/site_deployment_status/"),
    },
    support: {
      tickets: {
        list: url("/support/tickets/"),
        availableCompanies: url("/support/tickets/available_companies/"),
        externalData: {
          list: url("/support/tickets/:pk/external_data/"),
        },
        externalNotesAndTimeEntries: {
          list: url("/support/tickets/:pk/external_notes_and_time_entries/"),
          create: url("/support/tickets/:pk/add_external_note/"),
        },
      },
      issueTypes: {
        list: url("/support/issue_types/"),
      },
      incidentCategories: {
        list: url("/support/incident_categories/"),
      },
      incidentAffects: {
        list: url("/support/incident_affects/"),
      },
      incidentSeverity: {
        list: url("/support/incident_severity/"),
      },
      statuses: {
        list: url("/support/statuses/"),
      },
      teams: {
        list: url("/support/tickets/teams/"),
      },
      ticketAttachments: {
        list: url("/support/ticket_attachments/"),
      },
    },
    circuits: {
      list: url("/circuits/"),
      details: url("/circuits/:pk/"),
      monitoring: url("/circuits/monitoring/"),
    },
    changeManagement: {
      changes: {
        list: url("/change_management/changes/"),
      },
      changeEvents: {
        list: url("/change_management/change_events/"),
      },
      requests: {
        list: url("/change_management/change_requests/"),
        detail: url("/change_management/change_requests/:pk/"),
        downloadPdf: url(
          "/change_management/change_requests/:pk/download_pdf/",
        ),
        availableCompanies: url(
          "/change_management/change_requests/available_companies/",
        ),
      },
      requestApprovals: {
        list: url("/change_management/change_request_approvals/"),
        detail: url("/change_management/change_request_approvals/:unique_id/"),
        verifyUser: url(
          "/change_management/change_request_approvals/:unique_id/verify_user/",
        ),
        approve: url(
          "/change_management/change_request_approvals/:unique_id/approve/",
        ),
        reject: url(
          "/change_management/change_request_approvals/:unique_id/reject/",
        ),
      },
      requestEvents: {
        list: url("/change_management/change_request_events/"),
      },
    },
    SIMCards: {
      setTag: url("/sim_cards/:pk/set_tag/"),
      telcoInabox: {
        sim_cards: {
          list: url("/sim_cards/telcoinabox/sim_cards/"),
          details: url("/sim_cards/telcoinabox/sim_cards/:pk/"),
          balance: url("/sim_cards/telcoinabox/sim_cards/:pk/balance/"),
          setTag: url("/sim_cards/telcoinabox/sim_cards/:pk/set_tag/"),
        },
      },
    },
    companies: {
      companyProfile: {
        details: url("/companies/profile/"),
        companyContacts: {
          list: url("/companies/profile/contacts/"),
          details: url("/companies/profile/contacts/:pk/"),
          sendWhatsAppVerification: url(
            "/companies/profile/contacts/:pk/send-whatsapp-verification/",
          ),
          verifyWhatsAppNumber: url(
            "/companies/profile/contacts/:pk/verify-whatsapp-number/",
          ),
        },
        webhook: {
          details: url("/companies/profile/webhook/"),
          preview: url("/companies/profile/webhook/preview/"),
          testSend: url("/companies/profile/webhook/test-send/"),
          verify: url("/companies/profile/webhook/verify/"),
        },
        companyCustomers: {
          list: url("/companies/profile/customers/"),
        },
        customerAbbreviations: {
          list: url("/companies/profile/customer-abbreviations/"),
          details: url(
            "/companies/profile/customer-abbreviations/:customerId/",
          ),
        },
        applications: {
          list: url("/companies/applications/"),
        },
        userManagement: {
          list: url("/companies/users/"),
          details: url("/companies/users/:pk/"),
        },
        invitations: {
          list: url("/companies/user_invitations/"),
          resend: url("/companies/user_invitations/:pk/resend/"),
          getByKey: url(
            "/companies/user_invitations/:invitationKey/get_by_key/",
          ),
          accept: url("/companies/user_invitations/:invitationKey/accept/"),
        },
      },
    },
    contacts: {
      list: url("/contacts/"),
      ws: {
        list: url("/ws/contacts/listen/"),
        details: url("/ws/contacts/:pk/listen/"),
      },
      details: url("/contacts/:pk/"),
      categoryTypes: {
        list: url("/contacts/category_types/"),
      },
    },
    plugins: {},
    releaseNotes: url("/release_notes/"),
    permissions: {
      groups: {
        list: url("/permissions/groups/"),
      },
    },
    serviceMessages: {
      latest: url("/service-messages/latest/"),
    },
    netsgMobile: {
      services: {
        list: url("/netsg-mobile/services/"),
        details: url("/netsg-mobile/services/:pk/"),
        balance: url("/netsg-mobile/services/:pk/balance/"),
        setTag: url("/netsg-mobile/services/:pk/set-tag/"),
        hasNetsgMobile: url("/netsg-mobile/services/has-netsg-mobile/"),
        travelPacks: url("/netsg-mobile/services/:pk/travel-packs/"),
        buyTravelPack: url("/netsg-mobile/services/:pk/buy-travel-pack/"),
      },
      pools: {
        list: url("/netsg-mobile/pools/"),
        details: url("/netsg-mobile/pools/:pk/"),
        usage: url("/netsg-mobile/pools/:pk/usage/"),
      },
    },
  },
};
